import React, { createContext, useContext, useState } from 'react';

const SidebarContext = createContext(null);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    // Return default values if context is not available (for components outside SideNavigation)
    return { collapsed: false };
  }
  return context;
};

export const SidebarProvider = ({ children, collapsed, setCollapsed }) => {
  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContext;

